// extracted by mini-css-extract-plugin
export default {"container":"styles_container__xsmTQ","content":"styles_content__qfISL","logo":"styles_logo__+eSH2","copyright":"styles_copyright__DIXhb","links":"styles_links__pIJR+"};